module.exports = __webpack_public_path__ + "static/media/web_ecommerce.71ad185d.png";